/**
 * Agents who stay ON CALL for incoming chats while in Dev Mode (Lee, 4 Sep):
 * Natalie (nl), Nithish (np), Robert Biro (rb), info@wetech, Jennie Cave (jc)
 * and Lee Roche (lr). For them the incoming-chat ringer keeps ringing in Dev
 * Mode, and picking a chat up shifts them back to the Support side.
 * Matched on the login email's local part (the same convention the Dev Board
 * roster uses for its lane ids).
 */
const ON_CALL_LOCALS = new Set(['nl', 'np', 'rb', 'jc', 'lr', 'info'])

export function isOnCallInDevMode(agent: { email?: string } | null | undefined): boolean {
  const email = ((agent && agent.email) || '').trim().toLowerCase()
  const at = email.indexOf('@')
  if (at <= 0) return false
  return ON_CALL_LOCALS.has(email.slice(0, at))
}
